import { DirectionalHint, TooltipDelay } from "@fluentui/react";
import React, { useContext, useEffect, useRef, useState } from "react";
import { isMobile } from "react-device-detect";
import { useTranslation } from "react-i18next";
import CustomToolTipHost from "../../../../../../components/CustomToolTipHost/CustomToolTipHost";
import DialogBox from "../../../../../../components/Modal/DialogBox";
import DropDown from "../../../../../../components/SVGComponents/Tools/DropDown";
import HPIcon from "../../../../../../components/SVGComponents/Tools/HPIcon";
import studyReportContext from "../../../../../../context/studyreport/StudyReportContext";
import studyviewerContext from "../../../../../../context/studyviewer/StudyviewerContext";
import ViewportContext from "../../../../../../context/studyviewer/ViewportContext";
import themeContext from "../../../../../../context/theme/ThemeContext";
import {
  toolBarFlex,
  toolStyle,
  toolTipStyles,
} from "../../../../styles/styles";
import toastContext from "../../../../../../context/toast/ToastContext";
import { TOAST_TYPE } from "../../../../../../constants/Constants";

const HPTool = () => {
  const { t } = useTranslation();
  const { theme } = useContext(themeContext);
  const { showToastv2 } = useContext(toastContext);
  const [hoverManage, setHoverManage] = useState(false);
  const [showDropDown, setShowDropDown] = useState(false);

  const [hovered, setHovered] = useState(false);
  const [dropDownHovered, setDropDownHovered] = useState(false);
  const [showDialogBox, setShowDialogBox] = useState(false);
  const [dialogMessage, setDialogMessage] = useState("");
  const [showInputKeyImageModal, setShowInputKeyImageModal] = useState(false);
  const [showManageKeyImageModal, setShowManageKeyImageModal] = useState(false);
  // const [inputKeyImageTitle, setInputKeyImageTitle] = useState("");
  const { activeViewportIndex } = useContext(ViewportContext);
  const { applyHangingProtocol } = useContext(ViewportContext);
  const {
    savedKeyImages,
    setSavedKeyImages,
    unsavedKeyImages,
    setUnsavedKeyImages,
    keyImages,
    setKeyImages,
    isHPApplied,
    hpDataList,
    hpPercentageMap,
    appliedHp, setAppliedHp
  } = useContext(studyviewerContext);
  const dropDownRef = useRef(null);
  const handleMouseLeave = () => {
    setHovered(false);
  };

  const handleMouseOver = () => {
    setHovered(true);
  };

  const onHpClick = async (hpName) => {
    setShowDropDown(false);
    const selectedHp = hpDataList.find(hp => hp.name === hpName);
    
    if (selectedHp) {
      setAppliedHp(selectedHp);
    } else {
      console.warn(`HP with name "${hpName}" not found in hpDataList`);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropDownRef.current && !dropDownRef.current.contains(event.target)) {
        setShowDropDown(false);
      }
    };
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, []);

  const handleKeyImageClick = async () => {
    setShowInputKeyImageModal(true);
  };

  return (
    <>
      {isMobile ? (
        <>
          <div
            // onClick={() => setShowManageKeyImageModal(prev => !prev)}
            style={toolStyle}
          >
            <>
              <div
                style={{
                  height: "65%",
                  width: "60px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <div
                  className={
                    isMobile ? "highlight-tool-mobile" : "highlight-tool"
                  }
                >
                  <HPIcon
                    color={
                      hovered
                        ? theme.palette.activeTool
                        : theme.palette.inactiveTool
                    }
                  />
                </div>
              </div>
              <span
                style={{
                  fontSize: "9px",
                  lineHeight: "100%",
                  fontWeight: "400",
                  //color: "#FFFFFF",
                  color: "var(--mobile-color-txt)",
                }}
              >
                {"Hanging protocol"}
              </span>
            </>
          </div>
        </>
      ) : (
        <div style={{ display: "flex", flexDirection: "column" }}>
          <CustomToolTipHost
            delay={TooltipDelay.zero}
            id={"hanging-protocol"}
            directionalHint={DirectionalHint.rightCenter}
            styles={toolTipStyles}
            content={t("viewer.tools.hanging-protocol")}
            className={"myToolTip"}
          >
            <div
              className="highlight-tool"
              style={{
                width: "45px",
              }}
            >
              <div
                style={toolBarFlex}
                onMouseOver={handleMouseOver}
                onMouseLeave={handleMouseLeave}
                onClick={handleKeyImageClick}
              >
                <HPIcon
                  color={
                    hovered || isHPApplied
                      ? theme.palette.activeTool
                      : theme.palette.inactiveTool
                  }
                />
              </div>
              <div
                style={{
                  marginLeft: "10px",
                  display: "flex",
                  alignItems: "center",
                  height: "100%",
                }}
                onClick={() =>{
                  if(hpPercentageMap && hpPercentageMap.size > 0){
                    const hasNonZeroPercentage = Array.from(hpPercentageMap).some(([key, value]) => value !== 0);
                    if (hasNonZeroPercentage) {
                      setShowDropDown(!showDropDown);
                    }else{
                      showToastv2(TOAST_TYPE.INFO, t("hanging-protocol.no-suitable-protocol"));
                    }
                  }else{
                    showToastv2(TOAST_TYPE.INFO, t("hanging-protocol.no-suitable-protocol"));
                  }
                }}
                onMouseOver={() => setDropDownHovered(true)}
                onMouseLeave={() => setDropDownHovered(false)}
              >
                <DropDown
                  color={
                    dropDownHovered
                      ? theme.palette.activeTool
                      : theme.palette.inactiveTool
                  }
                />
              </div>
            </div>
          </CustomToolTipHost>
        </div>
      )}
      {showDropDown && (
        <div
          className={
            isMobile
              ? "dropdow-bottom-position viewer-tool-more-dropdown"
              : "dropdow-top-position viewer-tool-more-dropdown"
          }
          ref={dropDownRef}
          style={{
            flexDirection: "column",
            position: "absolute",
            // top : window.innerHeight * 0.075,
            zIndex: "999",
            // backgroundColor: "#201F1E",
            boxShadow:
              "0px 0.6px 1.8px rgba(0, 0, 0, 0.1), 0px 3.2px 7.2px rgba(0, 0, 0, 0.13)",
            borderRadius: "5px",
            paddingLeft: "10px",
            paddingRight: "20px",
          }}
        >
          {Array.from(hpPercentageMap)
            .filter(([key, value]) => value !== 0) // Filter out entries with value 0
            .map(([key, hp], index) => (
            <div
              key={key}
              onClick={() => onHpClick(key)}
              style={{
                color: key === appliedHp?.name ? "#0085FF" : "inherit",
              }}
              className="stack-scroll-dropdown-elements"
            >
              {key} 
              {/* ({hp?.layout?.rows}x{hp?.layout?.columns}) */}
            </div>
          ))}
        </div>
      )}
    </>
  );
};

export default HPTool;
